import { Component } from '@angular/core';
import {AdminAccessDirective} from "../../directives/admin-access.directive";
import {ButtonComponent} from "../../components/ui/button/button.component";
import {RouterOutlet} from "@angular/router";
import {TabComponent} from "../../components/ui/tab/tab.component";
import {TabsComponent} from "../../components/ui/tabs/tabs.component";
import {TitleComponent} from "../../components/ui/title/title.component";
import {TranslateModule} from "@ngx-translate/core";
import {ModalService} from "../../services/modal.service";
import {EditTagModalComponent} from "../../components/modals/edit-tag-modal/edit-tag-modal.component";

@Component({
  selector: 'app-tags',
  standalone: true,
    imports: [
        AdminAccessDirective,
        ButtonComponent,
        RouterOutlet,
        TabComponent,
        TabsComponent,
        TitleComponent,
        TranslateModule
    ],
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss'
})
export class TagsComponent {

  constructor(private modalService: ModalService) {
  }

  createTag() {
    this.modalService.open(EditTagModalComponent);
  }
}
